export default __webpack_public_path__ + "img/fail.45c0dce9.png";